let MessagePreprocessor = require('../messagepreprocessor');
const MHelpers = require('../messages/helpers');
const Message = require('../message');

let Messages = {
	message(room, fmt){
		/*{
			type: 'message',
			continuous,
			time: dt.time*1000,
			from: {
				id: dt.from,
				nick: dt.from_login,
				color: dt.color,
			},
			body: dt.message,
		}*/

		let $p = $('<div class="chat-msg msg-message">'
			+ '<div class="chat-msg-time"/>'
			+ '<div class="chat-msg-author"/>'
			+ '<div class="chat-msg-body"/>'
			+ '</div>'
		);

		$p.find('.chat-msg-time').text(MHelpers.getFmtDate(fmt.time));
		$p.find('.chat-msg-author').css({color: fmt.from.color}).text(fmt.from.nick + ":");
		$p.find('.chat-msg-body').html(MessagePreprocessor.preprocessMessageText(room, fmt.body));

		return $p;
	},

	message_private(room, fmt){
		let $p = $('<div class="chat-msg msg-private">'
			+ '<span style="color: gray;">(лс)</span> '
			+ '<div class="chat-msg-time"/>'
			+ '<span class="chat-msg-author from"/>→ '
			+ '<span class="chat-msg-author to"/>'
			+ '<div class="chat-msg-body"/>'
			+ '</div>'
		);

		$p.find('.chat-msg-time').text(MHelpers.getFmtDate(fmt.time));
		$p.find('.chat-msg-author.from').css({color: fmt.from.color}).text(fmt.from.nick);
		$p.find('.chat-msg-author.to').css({color: fmt.to.color}).text(fmt.to.nick + ':');
		$p.find('.chat-msg-body').html(MessagePreprocessor.preprocessMessageText(room, fmt.body));

		return $p;
	},

	message_me(room, fmt){
		let $p = $('<div class="chat-msg msg-me">'
			+ '<div class="chat-msg-time"/>'
			+ '<span style="color: gray;">*</span> '
			+ '<span class="chat-msg-author"/>'
			+ '<span class="chat-msg-body"/>'
			+ '</div>'
		);

		$p.find('.chat-msg-time').text(MHelpers.getFmtDate(fmt.time));
		$p.find('.chat-msg-author').css({color: fmt.from.color}).text(fmt.from.nick);
		$p.find('.chat-msg-body').html(MessagePreprocessor.preprocessMessageText(room, fmt.body));

		return $p;
	},

	message_event(room, fmt){
		let $p = $('<div class="chat-msg msg-event">'
			+ '<div class="chat-msg-time"/>'
			+ '<span class="chat-msg-author" style="border-bottom: dashed 1px; color: gray;">*</span>'
			+ '<span class="chat-msg-body"/>'
			+ '</div>'
		);

		$p.find('.chat-msg-time').text(MHelpers.getFmtDate(fmt.time));
		$p.find('.chat-msg-author').attr('title', 'Автор: ' + fmt.from.nick);
		$p.find('.chat-msg-body').html(MessagePreprocessor.preprocessMessageText(room, fmt.body));

		return $p;
	},

	message_offtop(room, fmt){
		let $p = $('<div class="chat-msg msg-offtop">'
			+ '<div class="chat-msg-time"/>'
			+ '<div class="chat-msg-author"/>'
			+ '<div class="chat-msg-body"/>'
			+ '</div>'
		);

		$p.find('.chat-msg-time').text(MHelpers.getFmtDate(fmt.time));
		$p.find('.chat-msg-author').css({color: fmt.from.color}).text(fmt.from.nick + ":");
		$p.find('.chat-msg-body').html('(( ' + MessagePreprocessor.preprocessMessageText(room, fmt.body) + ' ))');

		return $p;
	},

	sysmessage(room, fmt){
		let $p = MHelpers.sysmessageDiv(fmt);
		$p.find('.chat-msg-body').html(MessagePreprocessor.preprocessSysMessageText(room, fmt.body));
		return $p;
	},

	status_online(room, fmt){
		let $p = MHelpers.sysmessageDiv(fmt);
		$p.find('.chat-msg-body')
			.append(MHelpers.userSpan(fmt.user).css({color: room.chat.syscolor2}))
			.append(fmt.user.girl ? ' пришла в комнату' : ' пришел в комнату')
			;
		return $p;
	},

	status_offline(room, fmt){
		let $p = MHelpers.sysmessageDiv(fmt);
		$p.find('.chat-msg-body')
			.append(MHelpers.userSpan(fmt.user).css({color: room.chat.syscolor2}))
			.append(fmt.user.girl ? ' ушла из комнаты' : ' ушел из комнаты')
			;
		return $p;
	},

	status_change_nick(room, fmt){
		let $p = MHelpers.sysmessageDiv(fmt);
		$p.find('.chat-msg-body')
			.append(MHelpers.userSpan(fmt.user).css({color: room.chat.syscolor2}).text(fmt.user.old_name))
			.append(fmt.user.girl ? ' сменила ник на ' : ' сменил ник на ')
			.append(MHelpers.userSpan(fmt.user).css({color: room.chat.syscolor2}))
			;
		return $p;
	},

	status_change_gender(room, fmt){
		let $p = MHelpers.sysmessageDiv(fmt);
		$p.find('.chat-msg-body')
			.append(MHelpers.userSpan(fmt.user).css({color: room.chat.syscolor2}))
			.append(fmt.user.girl ? ' сменил пол на женский' : ' сменила пол на мужской')
			;
		return $p;
	},

	status_change_color(room, fmt){
		let $p = MHelpers.sysmessageDiv(fmt);

		if (fmt.user.name != ''){
			$p.find('.chat-msg-body')
				.append(MHelpers.userSpan(fmt.user).css({color: room.chat.syscolor2}))
				.append(fmt.user.girl ? ' сменила ' : ' сменил ')
				.append($('<span/>').css({color: fmt.user.color}).text('цвет'))
				;
		} else {
			$p.find('.chat-msg-body')
				.append('Вы сменили ')
				.append($('<span/>').css({color: fmt.user.color}).text('цвет'))
				;
		}
		return $p;
	},
};

module.exports = Messages;
